import SegmentationSurvey from "../components/SegmentationSurvey/SegmentationSurvey";
import UnderMaintenanceOrChildren from "../components/UnderMaintenanceOrChildren/UnderMaintenanceOrChildren";

const SegmentationSurveyPage = () => {
  return (
    <UnderMaintenanceOrChildren>
      <SegmentationSurvey />
    </UnderMaintenanceOrChildren>
  );
};

export default SegmentationSurveyPage;
